export default __webpack_public_path__ + "static/media/d-7.435722a9.png";